












import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

@Component({
    components: {
        SpinnerOverlay
    }
})
export default class CheckoutElementLayout extends Vue {
    @Prop({
        type: String,
        required: true
    })
    headingLabel!: string;

    @Prop({
        type: Boolean,
        default: false
    })
    showPlaceholder!: boolean;

    @Prop({
        type: Boolean,
        default: false
    })
    validationError!: boolean;
}
